import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
// import puzzleLogo from "../../assets/logo.svg";
import marketLogo from "../../assets/Market_Logo.svg";
import mobileMenuIcon from "../../assets/icons/mobileMenu.svg";
import closeIcon from "../../assets/icons/close.svg";
import { Column, Row } from "../Flex";
import MobileMenu from "./MobileMenu";
import SizedBox from "../SizedBox";
import SearchInput from "../SearchInput";
import Wallet from "../Wallet/Wallet";
import { observer } from "mobx-react-lite";
import { useStores } from "src/stores/useStores";
// import { useStores } from "@stores";

interface IProps {}

const Root = styled(Column)`
  width: 100%;
  background: #fff;
  align-items: center;
  z-index: 102;
  box-shadow: 0px 8px 56px rgba(54, 56, 112, 0.16);

  //todo check
  a {
    text-decoration: none;
  }
`;

const TopMenu = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 64px;
  padding: 0 16px;
  max-width: 1440px;
  z-index: 102;
  @media (min-width: 880px) {
    height: 80px;
  }
  box-sizing: border-box;
  background: #ffffff;

  .logo {
    height: 30px;
    @media (min-width: 880px) {
      height: 36px;
    }
  }

  .icon {
    cursor: pointer;
  }
`;

const MenuItem = styled(Link)<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: ${({ selected }) => (selected ? "#363870" : "#8082c5")};
  box-sizing: border-box;
  border-bottom: 4px solid
    ${({ selected }) => (selected ? "#7075e9" : "transparent")};
  height: 100%;
  margin: 0 12px;

  &:hover {
    border-bottom: 4px solid #c6c9f4;
    color: #7075e9;
  }
`;

const Mobile = styled.div`
  display: flex;
  min-width: fit-content;
  @media (min-width: 880px) {
    display: none;
  }
`;

const Desktop = styled.div`
  display: none;
  min-width: fit-content;
  @media (min-width: 880px) {
    height: 100%;
    display: flex;
  }
`;

const SearchWrapper = styled.div`
  display: flex;
  height: 100%;
  width: 250px;
  align-items: center;
  @media (min-width: 992px) {
    width: 320px;
  }
`

const isRoutesEquals = (a: string, b: string) =>
  a.replaceAll("/", "") === b.replaceAll("/", "");

let timeoutId: NodeJS.Timeout|null = null;

const Header: React.FC<IProps> = () => {
  const { accountStore, marketStore, walletStore } = useStores();
  const [mobileMenuOpened, setMobileMenuOpened] = useState(false);
  const [searchValue, setSearchValue] = useState<string>('');
  // const [bannerClosed, setBannerClosed] = useState(true);
  const location = useLocation();
  const toggleMenu = (state: boolean) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    document.body.classList.toggle("noscroll", state);
    setMobileMenuOpened(state);
  };

  const menuItems: any[] = [
    { name: "Market", link: '/' }
  ];

  if (accountStore.address) {
    menuItems.push({ name: "Wallet", link: '/wallet' });
  }

  menuItems.push({ name: 'DAO', link: '/dao'});

  useEffect(() => {
    marketStore.searchValue = '';
    walletStore.searchValue = '';
    walletStore.tmpSearchValue = '';
    marketStore.find();

    return () => {
      setSearchValue('');
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    }
  }, [location.pathname]);

  const searchFn = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    if (location.pathname === '/') {
      marketStore.searchValue = e.target.value;
    } else if (location.pathname.indexOf('wallet') >= 0 || location.pathname.indexOf('address')) {
      walletStore.tmpSearchValue = e.target.value;
    }

    timeoutId = setTimeout(() => {
      if (location.pathname === '/') {
        marketStore.find();
      } else if (location.pathname.indexOf('wallet') >= 0 || location.pathname.indexOf('address')) {
        walletStore.searchValue = walletStore.tmpSearchValue;
      }
    }, 1000);
  };

  return (
    <Root>
      <Mobile>
        <MobileMenu
          opened={mobileMenuOpened}
          onClose={() => toggleMenu(false)}
          {...{ bannerClosed: true }}
        />
      </Mobile>

      <TopMenu>
        <Row alignItems="center" crossAxisSize="max">
          <Link to="/">
            <img className="logo" src={marketLogo} alt="logo" />
          </Link>
          <Desktop>
            <SizedBox width={54} />
            {menuItems.map(({ name, link }) => (
              <MenuItem
                key={name}
                selected={isRoutesEquals(link, location.pathname)}
                to={link}
              >
                {name}
              </MenuItem>
            ))}
          </Desktop>
          <Desktop>
            <SizedBox width={60} />
            <SearchWrapper>
              <SearchInput
                style={{ height: 40 }}
                icon="search"
                placeholder="Collection, name or author"
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                  if (searchFn) {
                    searchFn(e);
                  }
                }}
              />
            </SearchWrapper>
          </Desktop>
        </Row>
        <Mobile>
          <img
            onClick={() => toggleMenu(!mobileMenuOpened)}
            className="icon"
            src={mobileMenuOpened ? closeIcon : mobileMenuIcon}
            alt="menuControl"
          />
        </Mobile>
        <Desktop>
          <Wallet />
        </Desktop>
      </TopMenu>
    </Root>
  );
};
export default observer(Header);
